var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgNewReleasesCampaign = function SvgNewReleasesCampaign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5.5l-3-1.5.5 3.5-2 2 3 .5 1.5 3 1.5-3 3-.5-2-2 .5-3.5-3 1.5zM4 20l7-7-7 7zm5 0l3.5-3.5L9 20zm-5-5l3.5-3.5L4 15z",
    fill: "#4C4C8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20l7-7m-2 7l3.5-3.5M4 15l3.5-3.5m8-6l-3-1.5.5 3.5-2 2 3 .5 1.5 3 1.5-3 3-.5-2-2 .5-3.5-3 1.5z",
    stroke: "#4C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgNewReleasesCampaign;